import { PortalBannerHeadline as View } from "ui-components";

export const BannerHeadline = () => {
	return (
		<View
			header="Cambodian maps portal"
			subheader="Welcome to the Cambodian GIS Maps Portal, your gateway to a wealth
						of geospatial information and resources for Cambodia. Our platform
						provides access to a comprehensive collection of maps, datasets, and
						spatial analyses, covering topics such as land use, infrastructure,
						natural resources, and more. Whether you're a researcher,
						policymaker, developer, or enthusiast, our portal offers
						user-friendly tools and high-quality data to support your work and
						projects. Explore, visualize, and download the latest geospatial
						data to enhance your understanding and decision-making in
						Cambodia's rapidly evolving landscape."
		/>
	);
};
